import { Component, OnInit, Inject } from '@angular/core';
import { Stock } from '@stockcare-storage/stock/stock';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { KeyboardTemplate } from '@stockcare-components/custom-keyboard/keyboard-templates';
import { SettingsService } from '@stockcare-services/settings-service/settings.service';

@Component({
  standalone: false,
  selector: 'app-patient-basket-edit-item',
  templateUrl: './patient-basket-edit-item.component.html',
  styleUrls: ['./patient-basket-edit-item.component.scss'],
})
export class PatientBasketEditItemComponent implements OnInit {
  error: boolean;
  alertMessage: string;
  updatedQuantity: number;
  enableCustomKeyboard: boolean = false;
  keyboardTemplate = KeyboardTemplate.Pin;
  keyboardValue: string;

  constructor(
    public dialogRef: MatDialogRef<PatientBasketEditItemComponent>,
    private settingsService: SettingsService,
    @Inject(MAT_DIALOG_DATA) public data: Stock
  ) {}

  ngOnInit() {
    this.updatedQuantity = this.data.quantity;
    this.enableCustomKeyboard = this.settingsService.enableCustomKeyboard();
    this.keyboardValue = this.updatedQuantity.toString();
  }

  get getInputMode() {
    if (this.enableCustomKeyboard) {
      return 'none';
    }
    return 'number';
  }

  cancel() {
    this.dialogRef.close(true);
  }

  confirm() {
    if (this.updatedQuantity <= this.data['availableStock']) {
      this.dialogRef.close({
        barcode: this.data.barcode,
        updatedQuantity: this.updatedQuantity,
        materialQuantity: this.data.quantity,
      });
    } else {
      this.error = true;
      this.alertMessage = 'Not enough available stock';
    }
  }

  
  public customKeyboardInput(inputText: string) {
    this.updatedQuantity = +inputText;
  }
}
